<template>
  <div>
    <div class="card">
      <div class="card-header">Reembolsos sem Nota para Pagamento</div>
      <div class="card-body">
        <b-tabs>
            <NREmployeesAll></NREmployeesAll>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import NREmployeesAll from './NREmployeesAll';

export default {
  components: {
    NREmployeesAll,
  }
}

</script>
